"use strict";

const REGEXEN = {
  section_start: /^\s*(#+)([^#].*)$/,
  code_bookend: /^```/,
}

const getSections = module.exports = md => {
  let lines = md.split('\n');
  let curSection = {rank: 0, sections: [], text: ''};
  let sections = [curSection];
  let sectionStack = [curSection];
  let inCode = false;
  lines.forEach(line => {
    if (line.match(REGEXEN.code_bookend)) {
      curSection.text += line + '\n';
      inCode = !inCode;
      return
    }
    let match = inCode ? null : line.match(REGEXEN.section_start);
    if (match) {
      curSection.text = curSection.text.trim();
      curSection = {
        title: match[2].trim(),
        rank: match[1].length,
        text: '',
        sections: [],
      }
      let parentSection = curSection;
      while (parentSection.rank >= curSection.rank) {
        parentSection = sectionStack.pop();
      }
      parentSection.sections.push(curSection);
      sectionStack.push(parentSection);
      sectionStack.push(curSection);
    } else {
      curSection.text += line + '\n';
    }
  })
  curSection.text = curSection.text.trim();
  return sections;
}



// WEBPACK FOOTER //
// ./src/lib/markdown-sections.js